import MuiFormGroup from '@mui/material/FormGroup';
import { forwardRef } from 'react';

const FormGroup = forwardRef((props, ref) => {
  return <MuiFormGroup ref={ref} {...props} />;
});
FormGroup.displayName = 'FormGroup';
export default FormGroup;
